module.exports = __webpack_public_path__ + "static/img/icon_first_en.a133fae9.png";